import React, { useEffect, useContext, useState } from 'react';

import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { EditorContext } from 'container/context/editorContext';
import ConfirmationModel from 'container/Dialogs/ConfirmationModel/ConfirmationModel';
import { saveDocument } from 'container/api';
import Document from './Document';
import SaveDocument from 'container/Dialogs/SaveDocument/SaveDocument';

const Documents = ({ search }) => {
  const dispatch = useDispatch();

  const editor = useContext(EditorContext);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [docLoading, setDocLoading] = useState(false);

  const { documents, selected } = useSelector(state => state.documents);
  const loading = useSelector(state => state.documents.loading);
  const { user } = useSelector(state => state.auth);
  const [shouldSaveDoc, setShouldSaveDoc] = useState(false);
  const [clickedDoc, setClickedDoc] = useState(null);

  const handleDocumentClick = doc => {
    if (selected?.id === doc.id) {
      return null;
    }
    if (!selected && editor.getText().length > 0) {
      setShouldSaveDoc(true);
    } else {
      dispatch.documents.updateDocument({
        body: editor.getHTML(),
        showToast: false,
      });
      dispatch.documents.setSelected(doc);
      editor.commands.setContent(doc.body);
      dispatch.utils.setOpenMobileChatMenu(false);
    }
  };

  const handleSaveDocument = async title => {
    try {
      setDocLoading(true);
      if (!selected && editor.getText().length) {
        const data = {
          user: user.id,
          title: title || 'Untitled Document',
          body: editor.getHTML(),
        };

        await saveDocument(data);
        dispatch.outliner.reset();
        dispatch.documents.setSelected(clickedDoc || null);
        if (clickedDoc) {
          editor.commands.setContent(clickedDoc.body);
        } else {
          editor.commands.setContent('');
        }
        editor.chain().focus().run();
        dispatch.documents.getDocuments();
      } else {
        dispatch.documents.updateDocument({
          body: editor.getHTML(),
          showToast: false,
        });
      }
    } catch (err) {
      console.log(err.message);
    } finally {
      setShouldSaveDoc(false);
      setDocLoading(false);
    }
  };

  const handleDelete = id => {
    dispatch.documents.deleteDocument({
      id,
      after: () => setSelectedDoc(null),
    });
    dispatch.documents.setSelected(null);
    editor.commands.setContent('');
  };

  const OverriteDocument = () => {
    if (clickedDoc) {
      editor.commands.setContent(clickedDoc.body);
      editor.chain().focus().run();
      dispatch.documents.setSelected(clickedDoc);
    }
  };

  useEffect(() => {
    dispatch.documents.getDocuments();
    // eslint-disable-next-line
  }, []);

  return (
    <Container>
      {documents.map(doc => {
        if (doc.title.toLowerCase().indexOf(search.toLowerCase()) > -1) {
          return (
            <React.Fragment key={doc.id}>
              <Document
                doc={doc}
                handleDocumentClick={handleDocumentClick}
                setSelectedDoc={setSelectedDoc}
                selectedDoc={selectedDoc}
                setClickedDoc={setClickedDoc}
              />
              {/* <DocumentItem
                className={selected?.id === doc?.id ? 'active' : ''}
                onClick={() => handleDocumentClick(doc)}
              >
                <p className='font-size-14'>{doc?.title}</p>
                <div className='bottom-row'>
                  <p className='font-size-10'>
                    {dayjs(doc.created_at).fromNow()}
                  </p>
                  <div
                    className='btn'
                    role='button'
                    onClick={e => {
                      e.stopPropagation();
                      setSelectedDoc(doc.id);
                    }}
                  >
                    <img src={assets.delete} alt='' />
                  </div>
                </div>
              </DocumentItem> */}
              <Divider />
            </React.Fragment>
          );
        } else {
          return null;
        }
      })}
      <ConfirmationModel
        open={selectedDoc}
        setOpen={() => setSelectedDoc(!selectedDoc)}
        action={() => handleDelete(selectedDoc.id)}
        descripiton='Are you sure you want to delete this document?'
        loading={loading}
      />
      {shouldSaveDoc && (
        <SaveDocument
          open={shouldSaveDoc}
          setOpen={setShouldSaveDoc}
          onSave={handleSaveDocument}
          docLoading={docLoading}
          onCancel={OverriteDocument}
        />
      )}
    </Container>
  );
};

export default Documents;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-left: 10px;
  padding-top: 20px;
  flex-grow: 1;
  height: 0px;
  overflow: auto;
  margin-bottom: 20px;

  & p {
    margin: 0px;
  }
`;

const Divider = styled.div`
  margin-block: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  &:last-child {
    display: none;
  }
`;
